module.exports = __webpack_public_path__ + "img/BKGG2.60169897.jpg";